import {Component} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {AuthService} from "../../shared/services/auth.service";
import {ActivatedRoute} from '@angular/router';
import { GoogleAnalyticsService } from '../../shared/services/google-analytics.service';
import { ForgotPasswordValidation } from '../../shared/validations/forgot-password.validation';
import { invalidIcon, verifiedImage, passwordIcon } from '../../utils/images';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  form: FormGroup;

  public errorMessage: string = ""

  public hideForm: boolean = false
  public showPassword: boolean = false;
  public showConfirmPassword: boolean = false;
  loader: boolean = false;

  invalidIcon = invalidIcon
  verifiedImage = verifiedImage
  passwordIcon = passwordIcon

  constructor(private authService: AuthService, private formBuilder: FormBuilder, private route: ActivatedRoute,
    private googleAnalytics: GoogleAnalyticsService) {
    this.form = ForgotPasswordValidation.createForgotPasswordForm(this.formBuilder);
  }

  togglePasswordVisibility(e: Event): void {
    e.preventDefault();
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(e: Event): void {
    e.preventDefault();
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  savePassword() {
    this.errorMessage = ''
    this.form.markAllAsTouched()
    if (this.form.invalid) return

    this.loader = true;

    let {email, new_password, confirm_password} = this.form.value

    const token = this.route.snapshot.params['token']

    this.authService.resetPassword({email, new_password, confirm_password}, token).subscribe(
      (res: any) => {
        this.loader = false;

        if (res.status === 200) {
          this.hideForm = true;
        }
      },
      error => {
        this.loader = false;
        this.errorMessage = error.error.errors
      }
    );
  }

  trackButtonClick(btn_name: any) {
    this.form.markAllAsTouched()
    if (this.form.invalid) return
    this.googleAnalytics.trackButtonClick({'button': btn_name, page: 'Forget Password'});
  }
}
